// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"11ed59b6","327":"f37fd6ab","454":"f608ffce","587":"d54690d3","870":"e11a584f"}[chunkId] + ".chunk.js";
};